export { TypeMemory } from './TypeMemory';
export { MemoriesForm } from './MemoriesForm';
